import {
  Box,
  Heading,
  Link,
  Text as UIText,
  ThemeUIStyleObject,
} from 'theme-ui';
import { checkUserEnteredUrl } from './utils';

export { Box, Container, Heading, Image, Link } from 'theme-ui';
export const Text = (props: any) => <UIText variant="body" {...props} />;
export const List = (props: any) => <Box as="ul" {...props} />;
export const OrderedList = (props: any) => <Box as="ol" {...props} />;
export const Strong = (props: any) => <Box as="strong" {...props} />;
export const Em = (props: any) => <Box as="em" {...props} />;
export const Paragraph = (props: any) => (
  <Text variant="paragraph" as="p" {...props} />
);
export const ListItem = (props: any) => (
  <Text variant="listItem" as="li" {...props} />
);
export const ResumeHeading = (props: any) => (
  <Heading {...props} variant="resumeHeading" as="h1" />
);
export const SectionHeading = (props: any) => (
  <Heading {...props} variant="sectionHeading" as="h2" />
);

export const SectionItemHeading = (props: {
  url?: string;
  children: React.ReactNode;
}) => {
  const urlInfo = checkUserEnteredUrl(props.url);

  if (urlInfo) {
    return (
      <Heading {...props} variant="sectionItemHeading" as="h2">
        <Link
          variant="inherit"
          href={urlInfo.validUrl}
          target="_blank"
          rel="noopener noreferrer nofollow ugc"
        >
          {props.children}
        </Link>
      </Heading>
    );
  } else {
    return <Heading {...props} variant="sectionItemHeading" as="h2" />;
  }
};

export const SectionItemSubHeading = (props: {
  url?: string;
  children: React.ReactNode;
}) => {
  const urlInfo = checkUserEnteredUrl(props.url);

  if (urlInfo) {
    return (
      <Heading {...props} variant="sectionItemSubHeading" as="h3">
        <Link
          variant="inherit"
          href={urlInfo.validUrl}
          target="_blank"
          rel="noopener noreferrer nofollow ugc"
        >
          {props.children}
        </Link>
      </Heading>
    );
  } else {
    return <Heading {...props} variant="sectionItemSubHeading" as="h3" />;
  }
};

type WebsiteLinkProps = {
  children?: React.ReactNode;
  sx?: ThemeUIStyleObject;
  url?: string;
};
export const WebsiteLink = (props: WebsiteLinkProps) => {
  const { children, sx, url } = props;
  const urlInfo = checkUserEnteredUrl(url);

  if (urlInfo) {
    return (
      <Link
        variant="inherit"
        href={urlInfo.validUrl}
        target="_blank"
        rel="noopener noreferrer nofollow ugc"
        sx={{
          overflowWrap: 'break-word',
          ...sx,
        }}
        {...props}
      >
        {children || urlInfo.humanizedUrl || urlInfo.validUrl}
      </Link>
    );
  } else {
    return <>{children || url}</>;
  }
};
